import { InputHTMLAttributes } from 'react';

import Icon from '../Icon';
import { CheckboxContainer, CheckMark, InputCheckbox } from './styles';

export type checkBoxState = 'active' | 'error' | 'success';

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  isChecked: boolean;
  state?: checkBoxState;
};
const onClickEnterKey = (
  e: React.KeyboardEvent<HTMLInputElement>,
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange']
) => {
  if (e.key === 'Enter') {
    onChange?.(e as unknown as React.ChangeEvent<HTMLInputElement>);
  }
};

const Checkbox: React.FC<CheckboxProps> = ({
  isChecked,
  state = 'active',
  ...otherProps
}) => (
  <CheckboxContainer className="omni-aria-hidden">
    <InputCheckbox
      aria-checked={isChecked}
      checked={isChecked}
      onChange={otherProps?.onChange}
      onKeyDown={(e) => onClickEnterKey(e, otherProps.onChange)}
      role="checkbox"
      state={state}
      type="checkbox"
      {...otherProps}
    />
    <Icon aria-hidden iconColor="white" iconName="InterfaceCheck" />
    <CheckMark aria-hidden state={state} />
  </CheckboxContainer>
);

export default Checkbox;
